import comparisonsJson from "@/services/static/data/comparativos.json"
import plansJson from "@/services/static/data/planos.json"
import type { PlansService } from "@/services/ports"
import type { Plan, PlanComparison, PlanModality } from "@/services/types"

const PLANS = plansJson as Plan[]
const COMPARISONS = comparisonsJson as PlanComparison[]

/**
 * Planos a partir dos arquivos versionados no repositorio.
 *
 * Async apesar de a leitura ser sincrona: o contrato da porta e o mesmo do
 * adapter HTTP. Ver `services/ports.ts`.
 */
export function createStaticPlansService(): PlansService {
  return {
    async listPlans(modality: PlanModality): Promise<Plan[]> {
      return PLANS.filter((plan) => plan.modality === modality)
    },

    async getComparison(modality: PlanModality): Promise<PlanComparison> {
      const comparison = COMPARISONS.find((item) => item.modality === modality)

      if (!comparison) {
        // Falha alta e imediata. Um comparativo faltando devolvido como `null`
        // apareceria como tabela vazia em producao, sem nada nos logs.
        throw new Error(`Comparativo nao encontrado para a modalidade "${modality}".`)
      }

      return comparison
    },
  }
}
